import * as React from 'react'
import * as styles from './style/index.scss'
import img_404 from '@assets/img/404.png'

const ErrorC = () => (
    <div className={styles.centered}>
        <img src={img_404}/>
        <span>啊哦~ 你访问的页面不见了</span>
    </div>
)

export default ErrorC
